module.exports = __webpack_public_path__ + "img/eastvillagedeck-v_1-474x632.5a4ec562.jpg";